import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryProduct } from 'Services/Features/CategoryProduct/Utils/categoryProductUtils';
import CustomLoader from 'Component/Common/CustomLoader';
import FindCategoryProduct from './Filter/FindCategoryProduct';
import CategoryProductTable from './CategoryProductTable';

const CategoryProductContain = () => {
    const dispatch = useDispatch();
    const categoryProducts = useSelector((state) => state.categoryProduct.categoryProducts);
    const loading = useSelector((state) => state.categoryProduct.loading);
    const error = useSelector((state) => state.categoryProduct.error);
    const [refetch, setRefetch] = useState(false);
    const filters = useSelector(state => state.categoryProduct.filters);

    useEffect(() => {
        dispatch(getCategoryProduct(filters));
        window.scrollTo(0, 0);
    }, [dispatch, refetch]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Fragment>
            <Col md="12" className="project-list">
                <Card className="px-3">
                    <FindCategoryProduct />
                </Card>
            </Col>
            <Col xl="12" className="xl-80">
                <Row>
                    {loading ? (
                        <CustomLoader />
                    ) : loading === false && categoryProducts.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <h5 style={{ fontSize: '24px' }}>Kategori Produk Tidak Ditemukan</h5>
                            </div>
                        </Col>
                    ) : (
                        <CategoryProductTable setRefetch={setRefetch} />
                    )}
                </Row>
                </Col>
        </Fragment>
    );
};

export default CategoryProductContain;